import React, { useState, useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';

const OfflineBanner = () => {
  const { t } = useLanguage();
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [wasOffline, setWasOffline] = useState(false);
  const [showReconnected, setShowReconnected] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      if (wasOffline) {
        setShowReconnected(true);
        setTimeout(() => setShowReconnected(false), 3000);
      }
    };
    const handleOffline = () => {
      setIsOnline(false);
      setWasOffline(true);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [wasOffline]);

  if (isOnline && !showReconnected) return null;

  return (
    <div className={`fixed bottom-4 left-1/2 -translate-x-1/2 z-50 max-w-[90vw] px-4 sm:px-6 py-3 rounded-2xl shadow-2xl flex items-center gap-3 text-sm font-semibold transition-all duration-500 ${
      isOnline
        ? 'bg-green-600 text-white'
        : 'bg-stone-900 text-white'
    }`}>
      <i className={`fas ${isOnline ? 'fa-wifi text-green-200' : 'fa-wifi-slash text-red-400'}`}></i>
      {isOnline ? t('connectionRestored') : t('noInternetConnection')}
    </div>
  );
};

export default OfflineBanner;
